import React from "react";
import {observer} from "mobx-react";
import {OrbitComponent} from "../../../../base-components/orbit-component/orbit-component";
import {CyClass} from "../../../../../../common/cy-classes";
import {
    IGameContextViewModel
} from "../../../../../services/game-runner/interfaces/game-context/game-context-view-model.interface";
import {RegulationParticipationTicketIdBox} from "./boxes/regulation-participation-ticket-id.box";
import {Check} from "@sparkware/app-utils";


interface ParticipationSessionIdComponentProps {
    gameContext: IGameContextViewModel;
}

export const RegulationParticipationTicketIdComponent = observer(
    class RegulationParticipationTicketIdComponent extends OrbitComponent<ParticipationSessionIdComponentProps> {
        render() {

            const ticketId = this.props.gameContext.gameSessionData.regulationParticipationTicketId;

            return (
                <RegulationParticipationTicketIdBox className={CyClass('cy-regulation-participation-ticket-id')} hidden={Check.isNullOrUndefined(ticketId)}>
                    {this.services.translation.translate('GAME_PARTICIPATION_ID', {participationID: ticketId})}
                </RegulationParticipationTicketIdBox>
            );
        }
    }
);